/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import wrapWithProvider from './src/store/store-provider'
import { initPostHog } from './src/analytics/posthog'

// Inject global styles
import './node_modules/slick-carousel/slick/slick.css'
import './node_modules/slick-carousel/slick/slick-theme.css'

export const wrapRootElement = wrapWithProvider

export const onClientEntry = () => {
  initPostHog()
}
